export default {
    carregando: false,
    items: [],
    selecionado: {},
    itemsPaginados: {}
}
